import { useAbility } from '@cast/shared-ability-data-access';

/** 
  Temporary solution introduced earlier without full context.
  Custom FF to control commitments/discounts visibility. Page modules would be a cleaner solution.
  However, it's currently unclear (backend ticket created) whether they impact backend logic (e.g. autoscaling decisions).
  Keeping this approach for now as it's already used by customers.
  TODO: (Daniel) revisit and replace with page modules: https://castai.atlassian.net/browse/UI-6307
*/
export const useIsHideDiscountsFeatureEnabled = () =>
  useAbility().can('view', 'FeaturePricingHideDiscounts');
